<app-dashboard-layout>
    <div class="container">
      <div class="lang-container">
        <app-switch-lang></app-switch-lang>
      </div>
      <a [routerLink]="'/'">
        <img src="../../../../assets/img/fruzty-logo-slogan.png" width="250" height="auto"/>
      </a>
      <div class="card-login">
        <div class="card-container">
          <div class="header-card">
            <h2 class="title-form">{{'ResetPasswordRequestPage.CardHeaderText' | translate}}</h2>
            <h3 class="subtitle-form">{{'ResetPasswordRequestPage.SubheaderCardText' | translate}}</h3>
          </div>
          <form [formGroup]="formGroup">
            <div class="p-fluid formgrid grid">
              <div class="field col-12" style="margin-bottom: 20px">
                <label class="label-form" for="email">{{'ResetPasswordRequestPage.EmailFieldLabel' | translate}}</label>
                <input class="input-style" id="email" type="text" pInputText formControlName="email"/>
                <small *ngIf="submit && formGroup.controls['email'].invalid" class="p-error">{{getErrorMessage('email')}}</small>
              </div>
              <div class="field col-12">
                <p-button label="{{'ResetPasswordRequestPage.SendButton' | translate}}" [loading]="loading" (click)="onSubmit()"/>
              </div>
              <div class="field col-12 font-small">
                <p-message style="font-size:.9em" *ngIf="success" severity="success" text="{{'ResetPasswordRequestPage.SuccessMessage' | translate}}"></p-message>
              </div>
              <div class="field col-12">
                <a class="link-second" [routerLink]="'/login'">{{'ResetPasswordRequestPage.BackLink' | translate}}</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
</app-dashboard-layout>

